import * as React from "react"
import { Link, graphql } from "gatsby"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons'
import { faArrowAltCircleRight, faArrowAltCircleLeft, faSyncAlt, faTag } from '@fortawesome/free-solid-svg-icons'

import Layout from "../components/layout"
import Seo from "../components/seo"
import kebabCase from "lodash/kebabCase"
import RecentPosts from "../components/recent-posts"
import "katex/dist/katex.min.css"

const BlogPostTemplate = ({ data, location }) => {
  const post = data.markdownRemark
  const siteTitle = data.site.siteMetadata?.title || `Title`
  const { previous, next } = data
  
  return (
    <Layout location={location} title={siteTitle}>
      <Seo
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
      />
      <article
        className="blog-post"
        itemScope
        itemType="http://schema.org/Article"
      >
        <header>
          <h1 itemProp="headline">{post.frontmatter.title}</h1>
            { post.frontmatter.update !== null
               ? <p><FontAwesomeIcon icon={faCalendarAlt} /> {post.frontmatter.date} &nbsp;&nbsp;&nbsp;
                    <FontAwesomeIcon icon={faSyncAlt} /> {post.frontmatter.update}</p>
               : <p><FontAwesomeIcon icon={faCalendarAlt} /> {post.frontmatter.date}</p>
            }
        </header>      
        <section
          dangerouslySetInnerHTML={{ __html: post.html }}
          itemProp="articleBody"
        />
        <ul className="blog-post-tags">
            {post.frontmatter.tags && post.frontmatter.tags.map((tag) => (
              <li className="blog-post-tag">
                <FontAwesomeIcon icon={faTag} />{` `}
                <Link to={`/tags/${kebabCase(tag)}`}>{tag}</Link>
              </li>
            ))}
        </ul>
        <hr />
      </article>
      <RecentPosts />
      <hr />
      <nav className="blog-post-nav">
        <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: 0,
          }}
        >
          <li>
            {previous && (
              <Link to={previous.fields.slug} rel="prev">
                <FontAwesomeIcon icon={faArrowAltCircleLeft} /> {previous.frontmatter.title}
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={next.fields.slug} rel="next">
                {next.frontmatter.title} <FontAwesomeIcon icon={faArrowAltCircleRight} />
              </Link>
            )}
          </li>
        </ul>
      </nav>
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug(
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(id: { eq: $id }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "YYYY.MM.DD")
        update(formatString: "YYYY.MM.DD")
        description
        tags
      }
    }
    previous: markdownRemark(id: { eq: $previousPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
    next: markdownRemark(id: { eq: $nextPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
  }
`
